<template>
  <div>
    <comment-header :fathertitle="fathertitle" :childtitle="''" :path="path">
    </comment-header>
    <a-card style="margin-top: 24px" :bordered="false" title="转换记录">
      <div slot="extra">
        <a-button type="primary" @click="modalObj.visible = true"
          >添加</a-button
        >
      </div>
      <a-table
        size="large"
        :data-source="data"
        row-key="id"
        :columns="columns"
        :pagination="{
          pageSize: queryParams.pageSize,
          total: queryParams.totalRecords,
          current: queryParams.pageIndex,
          onChange: onChangepage,
        }"
      >
        <template slot-scope="text, record" slot="actions">
          <a-dropdown>
            <a class="ant-dropdown-link" @click.prevent> 操作 </a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <a href="javascript:;" @click="onDownLoad(record, 1)"
                    >下载原模型</a
                  >
                </a-menu-item>
                <a-menu-item v-if="record.status == 3">
                  <a href="javascript:;" @click="onDownLoad(record, 2)"
                    >下载转换模型</a
                  >
                </a-menu-item>
                <a-menu-item v-if="record.status == 3&&showDownloadDecrypt">
                  <a href="javascript:;" @click="onDownLoad(record, 3)"
                    >下载转换模型(非加密)</a
                  >
                </a-menu-item>
                <a-menu-item v-if="record.status == 2">
                  <a href="javascript:;" @click="onReloadTrans(record)"
                    >重新转换</a
                  >
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
        <template slot-scope="text, record" slot="status">
          <a-tag
            :color="
              text == 3
                ? '#87d068'
                : text == 1
                ? '#2db7f5'
                : text == 2
                ? '#f50'
                : '#adadadd9'
            "
            >{{
              text == 3
                ? "已完成"
                : text == 2
                ? "中断"
                : text == 1
                ? "正在转换"
                : "待处理"
            }}</a-tag
          >
          <a-icon
            v-if="record.status == 2"
            @click="errorMsg(record)"
            style="color: red; cursor: pointer"
            type="exclamation-circle"
          />
        </template>
      </a-table>
    </a-card>
    <a-modal
      :title="modalObj.title"
      @cancel="modalObj.visible = false"
      :visible="modalObj.visible"
      :maskClosable="false"
      :afterClose="afterClose"
      width="600px"
    >
      <div class="upload-main">
        <div class="form-warp" v-show="active == 0">
          <a-form
            :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-row>
              <a-col :span="24">
                <a-form-item label="所属项目">
                  <a-select
                    placeholder="请选择项目"
                    show-search
                    @select="handleSelectProject"
                    option-filter-prop="children"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    v-decorator="[
                      'projectId',
                      { rules: [{ required: true, message: '请选择项目' }] },
                    ]"
                  >
                    <a-select-option v-for="p in projectList" :key="p.id">
                      {{ p.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="资源库">
                  <a-select
                    mode="multiple"
                    placeholder="请选择资源库"
                    v-decorator="[
                      'resourceFilePathId',
                      { rules: [{ required: true, message: '请选择资源库' }] },
                    ]"
                    show-search
                    option-filter-prop="children"
                    @search="handleSearch"
                    @popupScroll="handlePopupScroll"
                    @select="handleSelect"
                  >
                    <a-select-option
                      v-for="(p, index) in renderedOptions"
                      :key="index + 'p'"
                      :value="p.id"
                    >
                      {{ p.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="BModel的bchw">
                  <a-input
                    v-decorator="[
                      'bModelBchw',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入BModel的bchw选择项目',
                          },
                        ],
                      },
                    ]"
                    placeholder="请用空格进行分割"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="1684x">
                  <a-radio-group v-model="uploadData.flag">
                    <a-radio :value="1">是</a-radio>
                    <a-radio :value="0">否</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="24" :label-col="{ span: 24 }">
                <a-form-item label="上传模型"> </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="upload-warp" v-show="!initShow">
          <a-upload
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="uploadPath"
            @change="handleChange"
            :before-upload="beforeUpload"
            :headers="{}"
            :data="uploadData"
            :disabled="isTransform"
          >
            <div>
              <a-icon class="ioc" :type="iconUpload ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                {{ iconUpload ? "正在上传请稍后..." : "上传模型" }}
              </div>
            </div>
          </a-upload>
        </div>
        <section class="files" v-if="initShow">
          <ul>
            <li>
              <a-tooltip placement="topLeft" :title="fileName || '未知文件'">
                <div class="files-name">
                  {{ fileName || "未知文件" }}
                </div>
              </a-tooltip>
              <a-progress :percent="percent" :strokeWidth="20" />
            </li>
          </ul>
        </section>
      </div>
      <div slot="footer">
        <a-button type="primary" @click="modalObj.visible = false"
          >关闭</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import request from "@utils/request";
import debounce from "lodash/debounce";
import CommentHeader from "@components/header";
import * as projectManagement from "@api/projectManage";
import * as networkmodeltype from "@api/networkmodeltype_management";
import { requestUrl } from "@utils/request_url";
import { getConvertModelTask, getTramsList } from "@api/task_management";
import * as semiManagement from "@/api/semi_management";
const LOAD_NUM = 100;
const obj = {
  id: -1,
  name: "点击加载更多",
};
const columns = [
  {
    title: "项目名称",
    width: 200,
    dataIndex: "projectName",
    key: "projectName",
  },

  {
    title: "资源库名称",
    width: 300,
    dataIndex: "resourceName",
    key: "resourceName",
  },
  {
    title: "状态",
    width: 100,
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
  {
    title: "开始时间",
    width: 200,
    dataIndex: "submitTime",
    key: "submitTime",
    align: "center",
  },
  {
    title: "完成时间",
    width: 200,
    dataIndex: "completeTime",
    key: "completeTime",
    align: "center",
  },

  {
    title: "操作",
    width: 100,
    dataIndex: "actions",
    key: "actions",
    align: "center",
    scopedSlots: { customRender: "actions" },
  },
];
export default {
  name: "transform",
  components: {
    CommentHeader,
  },
  computed: {
    uploadPath() {
      return requestUrl + "/train/rest/file/upload_k_cloud_net_file";
    },
  },

  data() {
    return {
      modalObj: {
        visible: false,
        title: "上传模型",
      },
      showDownloadDecrypt:false,
      columns,
      data: [],
      queryParams: {
        page: 1,
        pageSize: 20,
        totalRecords: 1,
        pageIndex: 1,
        projectId: null,
        status: "",
      },
      uploadData: {
        flag: 0,
      },
      active: 0,
      allRenderedOptions: [],
      projectList: [], // 项目列表
      dataLoading: false,
      searchVal: "",
      renderedOptions: [],
      oriDataList: [],
      filterDataList: [],
      // 添加点击更多标识
      flag: false,
      networkModelTypeList: [],
      formLayout: {
        labelCol: {
          xs: { span: 7 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 10 },
          sm: { span: 16 },
        },
      },
      form: this.$form.createForm(this),
      initShow: false,
      percent: 0,
      fathertitle: "模型转换",
      path: "/train/transform",
      fileName: "",
      iconUpload: false,
      taskId: null,
      timer: null,
      isTransform: false,
      realTaskId: null,
      headers: {
        token: localStorage.getItem("ACCESS_TOKEN"),
      },
    };
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  created() {
    this.getAllProject();
    this.loadNetworkModelTypeList();
    this.getTramsLists();
  },
  methods: {
    onReloadTrans(record) {
      semiManagement.setConvert(record.id).then((res) => {
        this.$message.success("操作成功");
      });
    },
    errorMsg(record) {
      semiManagement.getTransBreakError({ id: record.id }).then((res) => {
        this.$error({
          title: "错误信息提示",
          content: `${res.data}`,
        });
      });
    },
    onDownLoad(row, type) {
      if (type == 1) {
        //'http://111.39.248.31:16000/api/' 去除/api/  2020-12-15

        window.location.href =
          requestUrl + "train" + row.preConvertModelPathName;
      } else if(type==2) {
        window.location.href =
          requestUrl + "/train/rest/file/download_convert_b_model/" + row.id;
      }
      else{
        window.location.href =
          requestUrl + "/train/rest/file/download_convert_b_model2/" + row.id;
      }
    },
    afterClose() {
      this.initShow = false;
      this.iconUpload = false;
      this.getTramsLists();
    },
    getTramsLists() {
      const { pageIndex, pageSize } = this.queryParams;
      getTramsList({ pageIndex, pageSize }).then((res) => {
        this.data = res.data.list;
      });
    },
    onChangepage(page, pageSize) {
      this.params.pageIndex = page;
      this.loadTask();
      clearInterval(this.updateStatusProgressTime);
      this.updateStatusProgressTime = setInterval(
        this.updateStatusProgress,
        1000
      );
    },
    nextStep() {
      const values = this.form.getFieldsValue();
      const userId = localStorage.getItem("user_id");
      const { flag } = this.uploadData;
      this.uploadData = {
        flag,
        ...values,
        userId,
        resourceFilePathId: values.resourceFilePathId.join(","),
      };
      //遍历对象，将值为undefined的属性删除
      for (let key in this.uploadData) {
        if (this.uploadData[key] === undefined) {
          delete this.uploadData[key];
        }
      }
    },
    handleSelectProject(val) {
      this.dataLoading = true;
      const self = this;
      this.renderedOptions = [];
      this.oriDataList = [];
      this.loadResourceList(val).then((res) => {
        this.dataLoading = false;
        //取前100条数据
        this.renderedOptions = res.data.list;
        this.oriDataList = res.data.list;
      });
    },
    //加载网络模型类型列表
    loadNetworkModelTypeList() {
      const self = this;
      networkmodeltype.getAll().then((res) => {
        self.networkModelTypeList = res.data;
      });
    },
    //加载项目
    getAllProject() {
      const self = this;
      projectManagement.getAllProject().then((r) => {
        self.projectList = [];
        for (let index = 0; index < r.data.length; index++) {
          const element = r.data[index];
          self.projectList.push({ id: element.id + "", name: element.name });
        }
      });
    },

    selectSemiSupervisedFlag(val) {
      if (val === 1) {
        this.showSemiSupervised = true;
      } else {
        this.showSemiSupervised = false;
      }
    },

    async loadResourceList(currentProjectId) {
      const resultData = [];
      const dataUrl =
        requestUrl +
        "/train/rest/label_file/get_label_resource_list/" +
        currentProjectId;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });
        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },

    // 文本框值变化时触发
    handleSearch(val) {
      this.searchVal = val;
      let filterList = [];
      if (val) {
        filterList = this.oriDataList.filter(
          (item) => item.name.indexOf(val) > -1
        );
      } else {
        filterList = this.oriDataList;
      }
      if (!this.flag) {
        filterList.push(obj);
      }
      this.filterDataList = filterList;
      this.renderedOptions =
        filterList.length < LOAD_NUM
          ? filterList
          : filterList.slice(0, LOAD_NUM);
    },
    // 滚动时触发（防止抖动）
    handlePopupScroll: debounce(function () {
      if (this.searchVal === "") {
        this.loadMoreData(this.oriDataList);
      } else {
        this.loadMoreData(this.filterDataList);
      }
    }, 400),
    // 加载更多数据到select框
    loadMoreData(dataList) {
      const renderedLen = this.renderedOptions.length; // 已渲染的下拉列表长度
      const totalLen = dataList.length; // 当前数据源的长度
      let addList = [];
      if (renderedLen < totalLen) {
        if (renderedLen + LOAD_NUM <= totalLen) {
          addList = dataList.slice(renderedLen, renderedLen + LOAD_NUM);
        } else {
          addList = dataList.slice(
            renderedLen,
            renderedLen + (totalLen % LOAD_NUM)
          );
        }
        this.renderedOptions = this.renderedOptions.concat(addList);
      }
    },
    // 被选中时调用，参数为选中项的 value (或 key) 值
    handleSelect(val) {
      // 表示选择点击更多
      if (val === -1) {
        this.flag = true;
        const self = this;
        self.dataLoading = true;
        const projectId = this.form.getFieldsValue().projectId;
        this.loadResourceList(projectId).then((res) => {
          const choiseNode = document.getElementsByClassName(
            "ant-select-selection__choice"
          );
          Array.from(choiseNode).forEach((item) => {
            if (item.innerText.indexOf("点击加载更多") > -1) {
              item.remove();
            }
          });
          self.dataLoading = false;
          let list = [];
          if (Object.prototype.hasOwnProperty.call(this.model, "pathIds")) {
            // 剔除list中存在的，避免重复
            for (var i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              if (this.model.pathIds.indexOf(item.id) === -1) {
                list.push(item);
              }
            }
          } else {
            list = res.data;
          }
          list.forEach((item) => {
            self.oriDataList.push(item);
          });
          let originalLenth = self.renderedOptions.length - 1;
          self.renderedOptions = self.renderedOptions.slice(0, originalLenth);
          list.slice(0, LOAD_NUM - originalLenth).forEach((item) => {
            self.renderedOptions.push(item);
          });
        });
      } else {
        if (this.searchVal) {
          const selectedArr = this.oriDataList.filter(
            (item) => item.id === val
          ); // 从数据源中过滤出下拉框选中的值，并返回一个数组
          const restList = this.oriDataList.filter((item) => item.id !== val); // 从数据源中过滤出其他的值，返回一个数组
          const newList = selectedArr.concat(restList).slice(0, LOAD_NUM); // 将选中的元素放到下拉列表的第一位
          this.renderedOptions = newList; // 更新已渲染的下拉列表
          if (!this.flag) {
            this.renderedOptions.push(obj);
          }
          this.oriDataList = selectedArr.concat(restList); // 更新数据源
          this.searchVal = ""; // 因为触发handleSelect函数时，会自动清空用户输入的内容。因此，searchVal需要重置。
        }
      }
    },
    downloadTrainBModel(record) {
      console.log(record);
      window.location.href =
        requestUrl + "/train/rest/file/download_train_b_model/" + record.id;
    },
    downloadTrainBModel2(record) {
      window.location.href =
        requestUrl + "/train/rest/file/download_train_b_model2/" + record.id;
    },
    async beforeUpload(file) {
      const result = await this.form.validateFields();
      this.nextStep();
      //获取文件后缀名
      const fileName = file.name;
      const fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExtension == "bmodel") {
        this.$message.error("该格式的文件不需要进行转换");
        return false;
      } else {
        this.fileName = fileName;
        this.initShow = true;
        return true;
      }
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        //info.file.percent 取整
        this.percent = parseInt(info.file.percent);
        this.iconUpload = true;
        return;
      }
      if (info.file.status === "done") {
        if (info.file.response.code === 10002) {
          this.iconUpload = false;
          this.$message.success("上传成功");
          this.modalObj.visible = false;
          // this.heartBeat();
        }
      }
    },
    //心跳监测
    // 管理员 和 某个固定id 用户（1e18f0a07b6647a692c8a9a4b29dd875） 能下载加密和非加密 其它的只能下载加密
    // 转换任务中不允许再次上传
    heartBeat() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        getConvertModelTask(this.taskId).then((res) => {
          const { status } = res.data;
          if (status === 2) {
            this.$message.success("转换成功");
            this.isTransform = false;
            clearInterval(this.timer);
          } else {
            //继续轮询
            this.isTransform = true;
          }
          console.log(res);
        });
      }, 1000);
    },
  },
  mounted() {
    var userType = localStorage.getItem("user_type");
    var userName = localStorage.getItem("user_name");
    if(userType==1 || userName=="1e18f0a07b6647a692c8a9a4b29dd875"){
      this.showDownloadDecrypt=true;
    }
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        this.getTramsLists();
      }, 2000);
    });
  },

  beforeDestroy() {
    console.log("销毁定时器");
    clearInterval(this.timer);
    
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
